import { useMemo } from "react";
import { Line, LineChart, YAxis } from "recharts";
import { useTheme } from "@mui/material/styles";

const WIDTH = 36;
const HEIGHT = 14;
const STROKE_WIDTH = 1.4;
/** A trend needs two points. */
const MIN_POINTS = 2;
/** Scaled from the lowest to the highest day, as the prototype draws it (not from 0). */
const Y_DOMAIN = ["dataMin", "dataMax"];

interface ProfitSparklineProps {
  /** Profit per day, oldest first. */
  trend: number[];
}

/** The profit cell's trend: green when the last day ends at or above the first, else red. */
export default function ProfitSparkline({ trend }: Readonly<ProfitSparklineProps>) {
  const theme = useTheme();
  const points = useMemo(() => trend.map((profit) => ({ profit })), [trend]);
  if (trend.length < MIN_POINTS) return null;
  const isRising = trend[trend.length - 1] >= trend[0];
  return (
    <LineChart
      width={WIDTH}
      height={HEIGHT}
      data={points}
      margin={{ top: 1, right: 1, bottom: 1, left: 1 }}
      style={{ display: "inline-block", verticalAlign: "middle", marginRight: 6 }}
    >
      <YAxis hide domain={Y_DOMAIN} />
      <Line
        type="linear"
        dataKey="profit"
        stroke={isRising ? theme.palette.success.dark : theme.palette.error.dark}
        strokeWidth={STROKE_WIDTH}
        dot={false}
        isAnimationActive={false}
      />
    </LineChart>
  );
}
